var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: {
        value: "",
        size: "lg",
        title: "Product base variants",
        "hide-close": "",
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-end align-items-center w-100",
                },
                [
                  _vm.canAddPrintSize
                    ? _c(_setup.CButton, {
                        attrs: {
                          variant: "outline-primary",
                          text: "Save and add another print size",
                          disabled: _setup.isSaving,
                        },
                        on: {
                          click: function ($event) {
                            return _setup.saveProduct(true)
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(_setup.CButton, {
                    attrs: {
                      variant: "primary",
                      text: "Save Product",
                      disabled: _setup.isSaving,
                    },
                    on: {
                      click: function ($event) {
                        return _setup.saveProduct()
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        _setup.ValidationObserver,
        {
          ref: "variantFormRef",
          staticClass: "variants-modal-wrapper",
          attrs: { tag: "div" },
        },
        [
          !_setup.model.variantOptions.length
            ? _c(_setup.CEmptyState, {
                staticClass: "empty-message",
                attrs: {
                  "icon-class": "icon-adjusted",
                  message:
                    "This product will be created without variant options. You can add one by clicking the button below.",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_setup.model.variantOptions, function (option, optionIdx) {
            return _c(
              "div",
              {
                key: `option-${optionIdx}`,
                staticClass: "variant-option-container border",
                class: { "preview-mode": optionIdx !== _setup.selectedVariant },
              },
              [
                optionIdx !== _setup.selectedVariant
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "flex-fill",
                          on: {
                            click: function ($event) {
                              return _setup.editVariantOption(optionIdx)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "option-title" }, [
                            _vm._v(_vm._s(option.name)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "option-values" },
                            _vm._l(option.values, function (value, valueIdx) {
                              return _c(
                                _setup.CBadge,
                                {
                                  key: `value-${option.name}-${valueIdx}`,
                                  attrs: { color: "cyan" },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(value.name) +
                                      "\n                            "
                                  ),
                                  value.hint.length
                                    ? _c(
                                        "span",
                                        { staticClass: "font-weight-normal" },
                                        [_vm._v("(" + _vm._s(value.hint) + ")")]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(_setup.CButton, {
                        attrs: { icon: ["far", "pen"] },
                        on: {
                          click: function ($event) {
                            return _setup.editVariantOption(optionIdx)
                          },
                        },
                      }),
                    ]
                  : [
                      _c("span", { staticClass: "option-title" }, [
                        _vm._v("Editing Variant Options"),
                      ]),
                      _vm._v(" "),
                      _c(_setup.ValidationProvider, {
                        attrs: { rules: "required", slim: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ failed }) {
                                return [
                                  _c(_setup.CInput, {
                                    attrs: {
                                      required: "",
                                      label: option.isPrintSizeVariant
                                        ? "Print size variant option name"
                                        : "Variant option name",
                                      error: failed,
                                      "error-msg":
                                        "You must write a name for the variant option.",
                                    },
                                    model: {
                                      value: option.name,
                                      callback: function ($$v) {
                                        _vm.$set(option, "name", $$v)
                                      },
                                      expression: "option.name",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "option-values" },
                        [
                          _vm._l(option.values, function (value, valueIdx) {
                            return _c(_setup.ValidationProvider, {
                              key: `value-${option.name}-${valueIdx}`,
                              staticClass: "row align-items-center",
                              attrs: {
                                tag: "div",
                                rules: {
                                  required: true,
                                  noDuplicate: {
                                    values: option.values,
                                    key: "name",
                                    index: valueIdx,
                                  },
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({
                                      failed,
                                      failedRules: { noDuplicate },
                                    }) {
                                      return [
                                        _c(_setup.CInput, {
                                          staticClass: "col",
                                          attrs: {
                                            id: `${option.name}-option-value-${valueIdx}`,
                                            value: value.name,
                                            required: "",
                                            disabled: option.readOnlyValues,
                                            label:
                                              valueIdx === 0
                                                ? "Variant option value"
                                                : "",
                                            error: failed,
                                            "error-msg":
                                              noDuplicate ||
                                              "You must add a value for the variant option.",
                                          },
                                          on: {
                                            enter: function ($event) {
                                              return _setup.addVariantValue(
                                                option
                                              )
                                            },
                                            input: function ($event) {
                                              return _setup.onVariantValueChange(
                                                $event,
                                                value,
                                                option
                                              )
                                            },
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              option.values.length > 1 &&
                                              !option.isPrintSizeVariant &&
                                              !option.readOnlyValues
                                                ? {
                                                    key: "append",
                                                    fn: function () {
                                                      return [
                                                        _c(_setup.CButton, {
                                                          attrs: {
                                                            icon: [
                                                              "far",
                                                              "trash-can",
                                                            ],
                                                            size: "sm",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _setup.deleteVariantValue(
                                                                option,
                                                                valueIdx
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  }
                                                : null,
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        value.hint.length
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-4 font-italic",
                                                class: {
                                                  "mt-4": valueIdx === 0,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(value.hint) +
                                                    "\n                        "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          }),
                          _vm._v(" "),
                          !option.isPrintSizeVariant && !option.readOnlyValues
                            ? [
                                _c(_setup.CButton, {
                                  attrs: {
                                    variant: "secondary",
                                    text: "Add another value",
                                    icon: ["far", "plus"],
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _setup.addVariantValue(option)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "You can add values quickly by pressing “enter” when writing."
                                  ),
                                ]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center",
                        },
                        [
                          !option.isPrintSizeVariant
                            ? _c(_setup.CButton, {
                                attrs: {
                                  variant: "outline-danger",
                                  text: "Delete",
                                  size: "sm",
                                  icon: ["far", "trash-can"],
                                },
                                on: {
                                  click: function ($event) {
                                    return _setup.deleteVariantOption(optionIdx)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(_setup.CButton, {
                            staticClass: "ml-auto",
                            attrs: {
                              variant: "outline-primary",
                              text: "Done",
                              size: "sm",
                            },
                            on: { click: _setup.saveVariantOption },
                          }),
                        ],
                        1
                      ),
                    ],
              ],
              2
            )
          }),
          _vm._v(" "),
          _setup.displayAddOptionBtn
            ? _c(_setup.CButton, {
                attrs: {
                  variant: "outline-primary",
                  text: "Add another variant option",
                  icon: ["far", "plus"],
                },
                on: { click: _setup.addVariantOption },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.displayDescription
            ? _c(_setup.CTextarea, {
                attrs: {
                  label: "Product description (optional)",
                  placeholder: "Add a description for this product...",
                },
                model: {
                  value: _setup.model.description,
                  callback: function ($$v) {
                    _vm.$set(_setup.model, "description", $$v)
                  },
                  expression: "model.description",
                },
              })
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }